/** PDF + Office extensions (aligned with platform shared/utils/contentType.ts). */
export const ACCEPTED_FILE_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'] as const;

export const ACCEPTED_FILE_TYPES = ACCEPTED_FILE_EXTENSIONS.map((ext) => `.${ext}`).join(',');

/** Returns true when the file is an allowed PDF/Office attachment. */
export function isAcceptedAttachmentFile(file: File): boolean {
  const ext = file.name.split('.').pop()?.toLowerCase();

  return ext != null && (ACCEPTED_FILE_EXTENSIONS as readonly string[]).includes(ext);
}
